/**
 * toastMessages — Central registry for repeated toast strings.
 *
 * Phase 1 scope (intentionally small): we extract only the high-frequency
 * duplicated strings identified in the toast audit. Each string here was
 * previously inlined in 2+ files with subtle wording / punctuation drift.
 *
 * Use these for new toast calls and when touching existing ones. We are NOT
 * migrating all 389 call sites in this pass — only the obvious duplicates
 * to start moving toward tone consistency.
 *
 * Tone:
 *   • Short, sentence case
 *   • One period at the end (no trailing "!" unless celebrating)
 *   • No "successfully" filler
 *   • No emoji icons
 */

export const TOAST = {
  // Auth / security
  PASSWORD_CHANGED: 'Password changed.',
  SECURITY_QUESTIONS_UPDATED: 'Security questions updated.',
  WELCOME_CUSTOMER: 'Welcome to Celey! Your account is ready.',
  WELCOME_VENDOR: 'Welcome to Celey! Your account is ready — complete your profile to start receiving inquiries.',
  EMAIL_UPDATED: 'Email updated. Please use your new email to log in.',
  PHONE_NUMBER_UPDATED: 'Phone number updated.',

  // Notes / feedback
  NOTE_ADDED: 'Note added.',
  FEEDBACK_SUBMITTED: 'Feedback submitted — thanks for helping us improve.',

  // Settings
  NOTIFICATION_PREFERENCE_UPDATED: 'Notification preference updated.',

  // Sharing
  REFERRAL_LINK_COPIED: 'Referral link copied.',
};
